import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const RootPage = () => {
  return (
    <ResponsivePage.Body>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default RootPage
